module.exports = __webpack_public_path__ + "img/introduce1.8d5fb5f7.png";